require('../../modules/es.symbol.iterator');
require('../../modules/es.string.iterator');
require('../../modules/web.dom-collections.iterator');

module.exports = require('../../internals/wrapped-well-known-symbol').f('iterator');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/es/symbol/iterator.js
// module id = 552
// module chunks = 0